import Tippy, { TippyProps } from '@tippyjs/react';
import React from 'react';

interface Props extends TippyProps {
  content: React.ReactNode;
}

const TooltipCard: React.FC<Props> = ({
  content,
  placement = 'bottom',
  className,
  children,
  ...tippyProps
}) => {
  return (
    <Tippy
      theme="card"
      arrow={false}
      className={className}
      placement={placement}
      content={content}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...tippyProps}
    >
      {children}
    </Tippy>
  );
};
export default TooltipCard;
